import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../core/services/api.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  private readonly api = inject(ApiService);

  readonly loading = signal(true);
  readonly error = signal<string | null>(null);
  readonly usersTotal = signal(0);
  readonly rentTotal = signal(0);
  readonly txTotal = signal(0);
  readonly cardProgramsTotal = signal(0);
  readonly kobbleConfigured = signal<boolean | null>(null);

  ngOnInit(): void {
    forkJoin({
      users: this.api.getUsers(1, 1),
      rent: this.api.getRentPayments(1, 1),
      tx: this.api.getTransactions(1, 1),
      programs: this.api.getCardPrograms().pipe(catchError(() => of([]))),
      kobble: this.api.getKobbleHealth().pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ users, rent, tx, programs, kobble }) => {
        this.usersTotal.set(users.total ?? 0);
        this.rentTotal.set(rent.total ?? 0);
        this.txTotal.set(tx.total ?? 0);
        this.cardProgramsTotal.set(Array.isArray(programs) ? programs.length : 0);
        this.kobbleConfigured.set(kobble ? !!kobble.configured : null);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load dashboard');
        this.loading.set(false);
      },
    });
  }
}
